import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid-random';
import { useTranslation } from 'react-i18next';
import DropDown from '..';
import HeaderComponent from '../HeaderComponent';
import { MenuOption, DropDownOption } from './styles';
import { useOutsideClick } from '../../../hooks';

const MenuDropdown = ({ optionSelected, tabsOptions, setCurrentTab, setQueryTab, sectionName }) => {
  const listRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  /**
   * @returns La funcion habilita el cierre de las opciones cuando hacemos click por fuera del contenedor.
   */
  const onCloseDropDown = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };
  useOutsideClick(listRef, onCloseDropDown);
  return (
    <DropDown
      isOpen={isOpen}
      setIsOpen={e => {
        e.stopPropagation();
        setIsOpen(!isOpen);
      }}
      title={isOpen}
      headerComponent={React.createElement(
        'div',
        {},
        <HeaderComponent isOpen={isOpen} text={t(`panel.${sectionName}.leftBar.title.${optionSelected}`)} isMenu />
      )}
      dataPanel='defaultOption'
    >
      <DropDownOption ref={listRef} isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
        {tabsOptions.map(option => (
          <MenuOption
            isSelected={option === optionSelected}
            key={uuid()}
            data-panel={`${sectionName}-mobile-tabLabel-${option}`}
            onClick={() => {
              if (option !== optionSelected) {
                setIsOpen(false);
                setCurrentTab(option);
                setQueryTab(option);
              }
            }}
          >
            {t(`panel.${sectionName}.leftBar.title.${option}`)}
          </MenuOption>
        ))}
      </DropDownOption>
    </DropDown>
  );
};

MenuDropdown.propTypes = {
  optionSelected: PropTypes.string.isRequired,
  tabsOptions: PropTypes.arrayOf(PropTypes.string).isRequired,
  setCurrentTab: PropTypes.func.isRequired,
  setQueryTab: PropTypes.func.isRequired,
  sectionName: PropTypes.string.isRequired
};

export default MenuDropdown;
